import type * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HomeAdaptiveSubjectsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HomeAdaptiveSubjectsQuery = { __typename?: 'RootQueryType', subjects?: { __typename?: 'KeysetPageOfSubject', results?: Array<{ __typename?: 'Subject', id: string, name: string, urlSlug: string }> | null } | null };

export type HomeAllAdaptiveSubjectsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HomeAllAdaptiveSubjectsQuery = { __typename?: 'RootQueryType', subjects?: { __typename?: 'KeysetPageOfSubject', results?: Array<{ __typename?: 'Subject', id: string, name: string, urlSlug: string }> | null } | null };


export const HomeAdaptiveSubjectsDocument = gql`
    query HomeAdaptiveSubjects {
  subjects(
    filter: {adaptive: {eq: true}, hidden: {eq: false}, includedInPersonalizationSettings: {eq: true}}
    sort: [{field: NAME, order: ASC}]
  ) {
    results {
      id
      name
      urlSlug
    }
  }
}
    `;

/**
 * __useHomeAdaptiveSubjectsQuery__
 *
 * To run a query within a React component, call `useHomeAdaptiveSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeAdaptiveSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeAdaptiveSubjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeAdaptiveSubjectsQuery(baseOptions?: Apollo.QueryHookOptions<HomeAdaptiveSubjectsQuery, HomeAdaptiveSubjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeAdaptiveSubjectsQuery, HomeAdaptiveSubjectsQueryVariables>(HomeAdaptiveSubjectsDocument, options);
      }
export function useHomeAdaptiveSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeAdaptiveSubjectsQuery, HomeAdaptiveSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeAdaptiveSubjectsQuery, HomeAdaptiveSubjectsQueryVariables>(HomeAdaptiveSubjectsDocument, options);
        }
// @ts-ignore
export function useHomeAdaptiveSubjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeAdaptiveSubjectsQuery, HomeAdaptiveSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<HomeAdaptiveSubjectsQuery, HomeAdaptiveSubjectsQueryVariables>;
export function useHomeAdaptiveSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeAdaptiveSubjectsQuery, HomeAdaptiveSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<HomeAdaptiveSubjectsQuery | undefined, HomeAdaptiveSubjectsQueryVariables>;
export function useHomeAdaptiveSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeAdaptiveSubjectsQuery, HomeAdaptiveSubjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeAdaptiveSubjectsQuery, HomeAdaptiveSubjectsQueryVariables>(HomeAdaptiveSubjectsDocument, options);
        }
export type HomeAdaptiveSubjectsQueryHookResult = ReturnType<typeof useHomeAdaptiveSubjectsQuery>;
export type HomeAdaptiveSubjectsLazyQueryHookResult = ReturnType<typeof useHomeAdaptiveSubjectsLazyQuery>;
export type HomeAdaptiveSubjectsSuspenseQueryHookResult = ReturnType<typeof useHomeAdaptiveSubjectsSuspenseQuery>;
export type HomeAdaptiveSubjectsQueryResult = Apollo.QueryResult<HomeAdaptiveSubjectsQuery, HomeAdaptiveSubjectsQueryVariables>;
export const HomeAllAdaptiveSubjectsDocument = gql`
    query HomeAllAdaptiveSubjects {
  subjects(
    filter: {adaptive: {eq: true}, hidden: {eq: false}}
    sort: [{field: NAME, order: ASC}]
  ) {
    results {
      id
      name
      urlSlug
    }
  }
}
    `;

/**
 * __useHomeAllAdaptiveSubjectsQuery__
 *
 * To run a query within a React component, call `useHomeAllAdaptiveSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeAllAdaptiveSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeAllAdaptiveSubjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeAllAdaptiveSubjectsQuery(baseOptions?: Apollo.QueryHookOptions<HomeAllAdaptiveSubjectsQuery, HomeAllAdaptiveSubjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeAllAdaptiveSubjectsQuery, HomeAllAdaptiveSubjectsQueryVariables>(HomeAllAdaptiveSubjectsDocument, options);
      }
export function useHomeAllAdaptiveSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeAllAdaptiveSubjectsQuery, HomeAllAdaptiveSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeAllAdaptiveSubjectsQuery, HomeAllAdaptiveSubjectsQueryVariables>(HomeAllAdaptiveSubjectsDocument, options);
        }
// @ts-ignore
export function useHomeAllAdaptiveSubjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeAllAdaptiveSubjectsQuery, HomeAllAdaptiveSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<HomeAllAdaptiveSubjectsQuery, HomeAllAdaptiveSubjectsQueryVariables>;
export function useHomeAllAdaptiveSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeAllAdaptiveSubjectsQuery, HomeAllAdaptiveSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<HomeAllAdaptiveSubjectsQuery | undefined, HomeAllAdaptiveSubjectsQueryVariables>;
export function useHomeAllAdaptiveSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeAllAdaptiveSubjectsQuery, HomeAllAdaptiveSubjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeAllAdaptiveSubjectsQuery, HomeAllAdaptiveSubjectsQueryVariables>(HomeAllAdaptiveSubjectsDocument, options);
        }
export type HomeAllAdaptiveSubjectsQueryHookResult = ReturnType<typeof useHomeAllAdaptiveSubjectsQuery>;
export type HomeAllAdaptiveSubjectsLazyQueryHookResult = ReturnType<typeof useHomeAllAdaptiveSubjectsLazyQuery>;
export type HomeAllAdaptiveSubjectsSuspenseQueryHookResult = ReturnType<typeof useHomeAllAdaptiveSubjectsSuspenseQuery>;
export type HomeAllAdaptiveSubjectsQueryResult = Apollo.QueryResult<HomeAllAdaptiveSubjectsQuery, HomeAllAdaptiveSubjectsQueryVariables>;